import React, { useState } from 'react';
import { blackTextLogo } from '../../assets/images/logos';
import { signupCover } from '../../assets/images/shooting';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import axios from 'axios';
import Notify from '../../utils/useNotify';
import { ArrowPathIcon } from '@heroicons/react/24/solid';

export default function Signup() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const localhost = process.env.REACT_APP_LOCALHOST;

  const [username, setusername] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confPassword, setconfPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const signup = async (e) => {
    e.preventDefault();
    setLoading(true); 
    try {
      if (password === confPassword) {
        const userData = { "username": username, "email": email, "password": password };
        const signupResponse = await axios.post(`${localhost}register`, userData);

        // Handle successful signup
        localStorage.removeItem("session_id");
        localStorage.setItem('token', signupResponse.data.token);
        localStorage.setItem('username', signupResponse.data.username);

        Notify('success', t('s-register'));
        setTimeout(() => { navigate("/") }, 500);
      } else {
        Notify('error', t('error-not-match'));
      }
    } catch (err) {
      // Handle error during signup
      if (err.request && err.request.status === 422) {
        const errormsg = JSON.parse(err.request.response);
        if (errormsg.errors.username) {
          Notify('error', t(errormsg.errors.username[0]));
        }
        if (errormsg.errors.email) {
          Notify('error', t(errormsg.errors.email[0]));
        }
      } else {
        Notify('error', t('e-register'));
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className='min-h-screen flex items-center justify-center'>
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-sm border lg:max-w-4xl">
        <div className="hidden bg-cover lg:block lg:w-1/2" style={{ backgroundImage: `url(${signupCover})` }}></div>

        <form onSubmit={signup} className="w-full px-6 py-8 md:px-8 lg:w-1/2">
          <a href='/' className="flex justify-center mx-auto">
            <img loading="lazy"  className="w-auto h-7 sm:h-8" src={blackTextLogo} alt="logo" />
          </a>

          <div className="mt-4">
            <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="Username">{t("username")}</label>
            <input id="Username" value={username} onChange={(e) => setusername(e.target.value)} className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="text" />
          </div>

          <div className="mt-4">
            <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="EmailAddress">{t("email")}</label>
            <input id="EmailAddress" value={email} onChange={(e) => setemail(e.target.value)} className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="email" />
          </div>

          <div className="mt-4">
            <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="psw">{t("password")}</label>
            <input id="psw" value={password} onChange={(e) => setpassword(e.target.value)} className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="password" />
          </div>

          <div className="mt-4">
            <label className="block mb-2 text-sm font-medium text-gray-600" htmlFor="conf-psw">{t("confirm-password")}</label>
            <input id="conf-psw" value={confPassword} onChange={(e) => setconfPassword(e.target.value)} className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300" type="password" />
          </div>

          <div className="mt-6">
            <button
              type="submit"
              className={`w-full px-6 py-2.5 rounded-lg text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform ${loading ? 'bg-black/60 cursor-not-allowed' : 'bg-black hover:bg-black/80'}`}
              disabled={loading}
            >
              {loading ? (
                <span className="flex justify-center items-center">
                  <ArrowPathIcon className="animate-spin text-white size-5 mr-1"/>
                  {t("loading")}
                </span>
              ) : (
                t("signup")
              )}
            </button>
          </div>

          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b md:w-1/4"></span>

            <a href="/signin" className="text-xs text-gray-500 uppercase hover:underline">{t("or-signin")}</a>

            <span className="w-1/5 border-b md:w-1/4"></span>
          </div>
        </form>
      </div>
    </section>
  )
}
